export default class OfferDetails {
  public static readonly LOCALE = "pl-PL";
  name: string = "";
  number: string = "";
  deliveryAddress: string = "";
  deliveryPeriodStart: string = "";
  deliveryPeriodEnd: string = "";
  expires: string = "";
  contactPerson: string = "";
  terms: string = "";
  warrantyPeriod: number = 0;

  public constructor(init?: Partial<OfferDetails>) {
    Object.assign(this, init);
  }

  get expiresDate(): Date {
    return new Date(this.expires);
  }

  get deliveryPeriodStartDate(): Date {
    return new Date(this.deliveryPeriodStart);
  }

  get deliveryPeriodEndDate(): Date {
    return new Date(this.deliveryPeriodEnd);
  }

  get expiresToLocalDateString(): string {
    return this.expiresDate.toLocaleString(OfferDetails.LOCALE);
  }

  get deliveryPeriod(): string {
    const options = { day: "numeric", month: "long", year: "numeric" };
    return `${this.deliveryPeriodStartDate.toLocaleString(
      OfferDetails.LOCALE,
      options
    )} - ${this.deliveryPeriodEndDate.toLocaleString(
      OfferDetails.LOCALE,
      options
    )}`;
  }
}
